import {Spin} from 'antd';
import React, {useCallback, useEffect, useState} from 'react';

import {useCustomTable} from 'components/@common/widgets/custom-table/custom-table';
import {selectContextRawData} from 'modules/context/context-selector';
import {IGroupProtocolDto} from 'pages/ais/organization-structure-v5/api/types';
import {useGroupProtocolColumns} from 'pages/ais/organization-structure-v5/hooks/use-group-protocol-columns';
import {
    GroupCompanyProtocolTabService
} from 'pages/ais/organization-structure-v5/services/group-company-protocol-tab.service';
import {ActionPanel} from 'pages/ais/organization-structure-v5/ui/action-panel';
import {usePagination} from 'shared/hooks/use-pagination';
import {useAppSelector} from 'store/config/hooks';

export const GroupCompanyProtocolTab = () => {
    const [tableData, setTableData] = useState<IGroupProtocolDto[]>();
    const [search, setSearch] = useState<string | null>(null);
    const [isLoadingTableData, setIsLoadingTableData] = useState<boolean>(false);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);

    const {pageSize, handleChange} = usePagination({pageDefault: 1, pageSizeDefault: 10});
    const {organizationId} = useAppSelector(selectContextRawData) ?? {};

    const fetchData = useCallback(async () => {
        try {
            setIsLoadingTableData(true);
            const {data} = await GroupCompanyProtocolTabService.get({
                paginationPageSize: pageSize,
                paginationCurrent: currentPage,
                search,
            });
            setTableData(data.dataTable);
            setTotalRows(data.recordsTotal);
            setIsLoadingTableData(false);
        } catch (e) {
            console.error('Ошибка получения записей: ', e);
        }
    }, [pageSize, currentPage, search]);

    const columns = useGroupProtocolColumns(tableData);

    useEffect(() => {
        fetchData();
    }, [pageSize, currentPage, search, organizationId]);

    const {customTableJSX} = useCustomTable({
        rowKey: 'id',
        pagination: {
            position: ['bottomLeft'],
            total: (() => totalRows)(),
            pageSize,
            onChange: (value: number) => {
                handleChange(value);
                setCurrentPage(value);
            },
        },
        className: 'mt-5',
        dataSource: tableData,
        bordered: true,
        columns,
    });

    return (
        <>
            <ActionPanel
                config={
                    {
                        setSearch,
                        isSearchDisabled: false,
                        isCreateDisabled: true,
                        isDeleteDisabled: true,
                        selectedRowKeys: [],
                        title: 'Протоколы обработки сведений по структуре группы компаний',
                    }
                }
            />
            <Spin spinning={isLoadingTableData}>{customTableJSX}</Spin>
        </>
    );
};